export default __webpack_public_path__ + "static/media/Kiunalla3.bd8ccd53.jpg";